import { render } from "./ButtonComponent.vue?vue&type=template&id=6253aa6c&scoped=true"
import script from "./ButtonComponent.vue?vue&type=script&lang=js"
export * from "./ButtonComponent.vue?vue&type=script&lang=js"

import "./ButtonComponent.vue?vue&type=style&index=0&id=6253aa6c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Shavin\\Documents\\apps\\Dont Get Got\\dont-get-got\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6253aa6c"]])

export default __exports__